import React, { useEffect, useState } from "react";
import { Box, MenuItem, Select, TextField } from "@material-ui/core";
import ReactModal from "react-modal";
import {
  WowcherCoupon,
} from "../../../../types/coupons";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { AppButton } from "../../ctaButton/button";
import { useDataProvider, useNotify } from "react-admin";

import "./style.css";

interface Props {
  coupon?: WowcherCoupon;
  refresh: () => void;
  closeModal: () => void;
  showModal: boolean;
}

const CouponPrices = [
  { text: "£5", key: 5 },
  { text: "£10", key: 10 },
  { text: "£20", key: 20 },
];

const CouponTickets = [
  { text: "15", key: 15 },
  { text: "50", key: 50 },
  { text: "150", key: 150 },
];

export const CouponWowcherCreateModal = ({
  closeModal,
  showModal,
  coupon,
  refresh,
}: Props) => {
  const notify = useNotify();
  const dataProvider = useDataProvider();
  const date = new Date();
  date.setFullYear(date.getFullYear() + 30);

  const [state, setState] = useState<WowcherCoupon>({
    _id: coupon?._id || "",
    couponId: coupon?.couponId || "",
    value: coupon?.value || 15,
    price: coupon?.price || 5,
    type: "WOWCHER",
    userEmail: coupon?.userEmail || "",
  });

  const [touchState, setTouch] = useState({
    couponId: false,
  });

  const [errors, setErrors] = useState({
    couponId: { status: false, message: "" },
  });

  useEffect(() => {
    setErrors({
      ...errors,
      couponId: {
        status: state.couponId.trim().length === 0 ? true : false,
        message: "Field is required",
      },
    });
  }, [state]);

  const handleChange = (e: any) => {
    let name = e.currentTarget.name;
    let value = e.currentTarget.value;
    setTouch({
      ...touchState,
      [name]: true,
    });

    setErrors((state) => ({
      ...errors,
      [name]: { ...state[name], status: false },
    }));

    setState({
      ...state,
      [e.target.name]: value.trim(),
    });
  };

  const handleSaveCoupon = async () => {
    if (!touchState.couponId) {
      setErrors({
        ...errors,
        couponId: { status: true, message: "Field is required" },
      });
      notify("Please check fields ", "error");
      return;
    }
    let withErrors = false;
    Object.keys(errors).map((key) => {
      if (errors[key].status) {
        withErrors = true;
        return;
      }
    });

    if (!withErrors) {
      let data = {
        ...state,
      };
      Object.keys(state).map((key) => {
        if (!data[key]) {
          delete data[key];
        }
      });

      try {
        const result = (await dataProvider.addCoupon("/coupons/referral", data)) as any;
        if (result.data) {
          notify("Wowcher coupon added", "info");
          closeModal();
          refresh();
        }
      } catch (error: any) {
        notify(error.data.error, "error");
      }
    } else {
      notify("Please check fields ", "error");
    }
  };

  const handleDropdownChange = (event) => {
      const name = event.target.name;
      const value = event.target.value;
      setState({ ...state, [name]: value, });
    };

  return (
    <div>
      <ReactModal
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        appElement={document.getElementById("root")}
        onClose={closeModal}
        isOpen={showModal}
        contentLabel="Inline Styles Modal Example"
        className="globalModalWrapper"
        style={{
          overlay: {
            backgroundColor: "rgba(9, 16, 29, 0.6)",
            zIndex: 10,
            width: "100%",
            display: "flex",
            alignItems: "center",
          },
        }}
      >
        <div className="couponModalContentWrapper">
          <div className="modalHeader">
              <span>Add Coupon</span>
          </div>
          <div className="modalBody modalBody_create">
            <div className="fieldsRow">
              <div className="side">
                <CreateCouponField
                  fieldTitle="Coupon #"
                  field={
                    <Box width={"90%"}>
                      <TextField
                        label=""
                        size="small"
                        variant="outlined"
                        type="text"
                        name="couponId"
                        error={errors.couponId.status}
                        onChange={handleChange}
                        value={state.couponId}
                      />
                    </Box>
                  }
                />
                {errors.couponId.status && (
                  <span className="fieldErrorMessage">
                    {errors.couponId.message}
                  </span>
                )}
              </div>
            </div>
            <div className="fieldsRow">
            </div>
            <div className="fieldsRow">
            </div>
            <div className="fieldsRow">
              <div className="side">
                <CreateCouponField
                  fieldTitle="Price"
                  field={
                    <Box width={"90%"}>
                      <Select
                        id="couponPrice"
                        variant="outlined"
                        value={state.price}
                        name={"price"}
                        onChange={handleDropdownChange}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        {CouponPrices.map((item) => (
                          <MenuItem key={item.key} value={item.key}>
                            {item.text}
                          </MenuItem>
                        ))}
                      </Select>
                    </Box>
                  }
                />
              </div>
              <div className="side">
                <CreateCouponField
                  fieldTitle="Tickets"
                  field={
                    <Box width={"90%"}>
                      <Select
                        id="couponTickets"
                        variant="outlined"
                        value={state.value}
                        name={"value"}
                        onChange={handleDropdownChange}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        {CouponTickets.map((item) => (
                          <MenuItem key={item.key} value={item.key}>
                            {item.text}
                          </MenuItem>
                        ))}
                      </Select>
                    </Box>
                  }
                />
              </div>
            </div>
          </div>
          <div className="modalFooter modalFooter_create">
            <AppButton onClick={handleSaveCoupon} size="long" text="Ok" />
          </div>
        </div>
      </ReactModal>
    </div>
  );
};

interface CouponCreateField {
  fieldTitle: string;
  fieldTemplate?: "inline" | "default";
  field: React.ReactNode;
}
const CreateCouponField = ({
  fieldTitle,
  field,
  fieldTemplate,
}: CouponCreateField) => {
  return (
    <div className={fieldTemplate === "inline" ? "row inline" : "row"}>
      <p className="fieldHeader">{fieldTitle}</p>
      <div className="fieldWrapper">{field}</div>
    </div>
  );
};
